import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NvDonutTileComponent } from './nv-donut-tile.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NvSharedTooltipModule } from 'projects/shared/nvps-libraries/design/nv-tooltip/nv-shared-tooltip.module';
import { EmptyStateDashboardTileModule } from 'projects/shared/components/empty-state-dashboard-tile/empty-state-dashboard-tile.module';
import { NvProgressDonutModule } from '../../nv-progress-donut/nv-progress-donut.module';

@NgModule({
  imports: [
    CommonModule,
    NvProgressDonutModule,
    NvSharedTooltipModule,
    NgxSkeletonLoaderModule,
    EmptyStateDashboardTileModule,
  ],
  exports: [NvDonutTileComponent],
  declarations: [NvDonutTileComponent],
  providers: [],
})
export class NvDonutTileModule {}
